// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleAndDescription-module__title--1j14y","description":"TitleAndDescription-module__description--2mAfr"};